import { useQuery } from '@tanstack/react-query';
import { queryKeys, rolesService } from '@v2/services';

export const useRoles = () => {
  const query = useQuery({
    queryKey: queryKeys.roles.lists(),
    queryFn: rolesService.getRoles,
  });

  return {
    roles: query.data ?? [],
    loading: query.isLoading,
    error: query.error instanceof Error ? query.error.message : null,
    refetch: query.refetch,
  };
};

export default useRoles;
